import * as Sentry from '@sentry/react'

/**
 * Set user context in Sentry
 */
export function setSentryUser(userId: string | null, tenantId?: string | null): void {
  if (userId) {
    Sentry.setUser({
      id: userId,
      // Don't include email or other PII
    })

    // Set tenant ID as a tag
    if (tenantId) {
      Sentry.setTag('tenant_id', tenantId)
    } else {
      Sentry.setTag('tenant_id', 'unknown')
    }
  } else {
    // Clear user context on logout
    Sentry.setUser(null)
    Sentry.setTag('tenant_id', null)
  }
}

/**
 * Set additional context tags
 */
export function setSentryTags(tags: Record<string, string | number | boolean | null>): void {
  Object.entries(tags).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      Sentry.setTag(key, String(value))
    } else {
      Sentry.setTag(key, null)
    }
  })
}

/**
 * Set additional context data
 */
export function setSentryContext(name: string, context: Record<string, any>): void {
  Sentry.setContext(name, context)
}

/**
 * Capture an exception manually
 */
export function captureException(error: Error, context?: Record<string, any>): void {
  if (context) {
    Sentry.withScope(scope => {
      Object.entries(context).forEach(([key, value]) => {
        scope.setContext(key, value)
      })
      Sentry.captureException(error)
    })
  } else {
    Sentry.captureException(error)
  }
}

/**
 * Add breadcrumb for user actions
 */
export function addBreadcrumb(
  message: string,
  category?: string,
  level?: 'info' | 'warning' | 'error',
  data?: Record<string, any>,
): void {
  Sentry.addBreadcrumb({
    message,
    category: category || 'user',
    level: level || 'info',
    data: data || {},
  })
}
